import { DocumentDownloadService } from '@xengage/gw-portals-document-js';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';

export default class GatewayClaimDocumentService {
    static getClaimDocument(documentID, token) {
        // DE20434 getDocumentLink function now attempts to download instead of
        // returning a link
        const baseURL = getProxiedServiceUrl('claimDownloadDocument');
        return `${baseURL}/${documentID}?token=${token}`;
    }
}
